/**
 * Utility functions for working with categories
 */

/**
 * Ensure all parent categories in a path are expanded, collapsing all others
 * @param {string|array} path - The path to expand
 * @param {Function} setExpandedCategories - The state setter for expandedCategories
 */
export const expandCategoryPath = (path, setExpandedCategories) => {
  if (!path) return

  // Start with a FRESH empty state - this collapses all other paths
  const newExpandedCategories = {}

  const pathSegments = typeof path === "string" ? path.split("/") : path

  // Build each cumulative path and expand it
  let currentPath = ""
  for (const segment of pathSegments) {
    if (segment) {
      // Skip empty segments
      if (currentPath === "") {
        currentPath = segment
      } else {
        currentPath = `${currentPath}/${segment}`
      }
      // Mark each progressive path part as expanded
      if (currentPath) {
        newExpandedCategories[currentPath] = true
      }
    }
  }

  // Replace (not merge) the expanded categories to collapse everything else
  setExpandedCategories(newExpandedCategories)
}
